export const EVERETTLABS_SUPPORT_URL = 'https://everettlabs.dev/coffee/';
